import { useEffect } from 'react';

type Input = {
  onDocumentVisible?: () => void;
  onDocumentHidden?: () => void;
};
/**
 * Invoke a callback when a document becomes visible or is hidden.
 *
 * Useful for triggering events on tab arrival or departure.
 *
 * Be sure to pass React.useCallback or immutable methods as arguments to this hook to reduce the amount of event re-binding.
 */
const useHandleDocumentVisibility = ({ onDocumentVisible, onDocumentHidden }: Input) => {
  useEffect(() => {
    let cleanUp;
    const handleDocumentVisibilityChange = () => {
      if (document.visibilityState === 'visible') {
        onDocumentVisible?.();
      } else {
        onDocumentHidden?.();
      }
    };

    if (typeof document !== 'undefined') {
      document.addEventListener('visibilitychange', handleDocumentVisibilityChange);
      cleanUp = () => document.removeEventListener('visibilitychange', handleDocumentVisibilityChange);
    }
    return cleanUp;
  }, [onDocumentVisible, onDocumentHidden]);
};

export default useHandleDocumentVisibility;
